import _ from "lodash";
import { createSlice } from "@reduxjs/toolkit";
import { createEncryptedAsyncThunk } from "../../Utility/APIUtils";
import { rowPerPage } from "../../../components/common/constant";

const initialState = {
  error: "",
  loading: false,
};

export const getCreditDebitDetailsAction = createEncryptedAsyncThunk(
  "CreditDebit/getCreditDebitDetailsAction",
  "Wallet/GetCreditDebitDetails",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      ledger_user_id: _.toNumber(params.ledger_user_id) || 0,
      role_Id: Array.isArray(params.role_Id)
        ? params.role_Id
        : [_.toNumber(params.role_Id)],
      transaction_type: params.transaction_type || "",
      startDate: params.fromDate || null,
      endDate: params.toDate || null,
    }),
  },
);

export const manageCreditDebitAction = createEncryptedAsyncThunk(
  "CreditDebit/manageCreditDebitAction",
  "Wallet/AddWalletTopup",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      from_user_id: params.from_user_id ? `${params.from_user_id}` : "",
      to_user_id: params.to_user_id ? `${params.to_user_id}` : "",
      trans_type: params.trans_type || "",
      topup_mode: 0,
      walletType: params.topup_mode || 1,
      otp: params.otp || "",
      amount: _.toNumber(params.amount) || 0,
      narration: params.narration || "",
      created_by: 0,
      tpin: params.tpin || "",
    }),
  },
);

export const adminGetAPIRequestResponseLog = createEncryptedAsyncThunk(
  "adminReportSlice/adminGetAPIRequestResponseLog",
  "Service/GetAPIRequestResponseLog",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      reference_Id: params.referenceId || "",
      service_Id: params.serviceId || 0,
      transaction_type: params.transaction_type || "",
      startDate: params.fromDate,
      endDate: params.toDate,
      pageNo: params.pageNumber || 1,
      pageSize: params.pageSize || rowPerPage,
    }),
  },
);

export const getSMSLogs = createEncryptedAsyncThunk(
  "adminReportSlice/adminGetAPIRequestResponseLog",
  "account/GetSMSLog",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      smstype: params.selectTemplate || "",
      req_startDate: params.fromDate,
      req_endDate: params.toDate,
    }),
  },
);

export const createFundTransferRequest = createEncryptedAsyncThunk(
  "transferRequestSlice/createFundTransferRequest",
  "Wallet/CreateFundTransferRequest",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      req_mode: _.toNumber(params.req_mode) || 0,
      req_from: `${params.req_from}` || "",
      req_to: `${params.req_to}` || "",
      from_bank_id: params.from_bank_id || 0,
      to_bank_id: params.to_bank_id || 0,
      transaction_id: params.transaction_id || "",
      deposite_date: params.deposite_date || "",
      transaction_proof: params.transaction_proof || "",
      amount: _.toNumber(params.amount) || 0,
      less_advance_amt: params.less_advance_amt || 0,
      approved_amt: params.approved_amt || 0,
      remark: params.remark || "",
      status: params.status || 0,
      payment_status: params.payment_status || 0,
      request_remark: params.request_remark || "",
    }),
  },
);

export const getWalletTopupDetailsAction = createEncryptedAsyncThunk(
  "reportSlice/getWalletTopupDetailsAction",
  "Wallet/GetWalletTopupDetails",
  {
    prepareBody: (params) => ({
      userID: params.currentUser.userGuid,
      trans_type: params.trans_type || "",
      topupReportId: params.topupReportId || 0,
      req_startDate: params.fromDate || null,
      req_endDate: params.toDate || null,
    }),
  },
);

export const CreditDebit = createSlice({
  name: "CreditDebit",
  initialState,
  reducers: {},
});

export default CreditDebit.reducer;
